export const GET_AUTOMATION_SETTINGS_REQ = 'GET_AUTOMATION_SETTINGS_REQ';
export const GET_AUTOMATION_SETTINGS_SUCCESS =
  'GET_AUTOMATION_SETTINGS_SUCCESS';
export const GET_AUTOMATION_SETTINGS_FAIL = 'GET_AUTOMATION_SETTINGS_FAIL';

export const CREATE_AUTOMATION_SETTINGS_REQ = 'CREATE_AUTOMATION_SETTINGS_REQ';
export const CREATE_AUTOMATION_SETTINGS_SUCCESS =
  'CREATE_AUTOMATION_SETTINGS_SUCCESS';
export const CREATE_AUTOMATION_SETTINGS_FAIL =
  'CREATE_AUTOMATION_SETTINGS_FAIL';

export const CREATE_AUTOMATION_SETTINGS_RESET =
  'CREATE_AUTOMATION_SETTINGS_RESET';

export const UPDATE_AUTOMATION_SETTINGS_REQ = 'UPDATE_AUTOMATION_SETTINGS_REQ';
export const UPDATE_AUTOMATION_SETTINGS_SUCCESS =
  'UPDATE_AUTOMATION_SETTINGS_SUCCESS';
export const UPDATE_AUTOMATION_SETTINGS_FAIL =
  'UPDATE_AUTOMATION_SETTINGS_FAIL';
export const UPDATE_AUTOMATION_SETTINGS_RESET =
  'UPDATE_AUTOMATION_SETTINGS_RESET';

export const UPDATE_ACTIVATE_AUTOMATION_SETTINGS_REQ =
  'UPDATE_ACTIVATE_AUTOMATION_SETTINGS_REQ';
export const UPDATE_ACTIVATE_AUTOMATION_SETTINGS_SUCCESS =
  'UPDATE_ACTIVATE_AUTOMATION_SETTINGS_SUCCESS';
export const UPDATE_ACTIVATE_AUTOMATION_SETTINGS_FAIL =
  'UPDATE_ACTIVATE_AUTOMATION_SETTINGS_FAIL';

export const DELETE_AUTOMATION_SETTINGS_REQ = 'DELETE_AUTOMATION_SETTINGS_REQ';
export const DELETE_AUTOMATION_SETTINGS_SUCCESS =
  'DELETE_AUTOMATION_SETTINGS_SUCCESS';
export const DELETE_AUTOMATION_SETTINGS_FAIL =
  'DELETE_AUTOMATION_SETTINGS_FAIL';
